import type { PageConfig, SiteConfig, Stats } from "./types";

const salesmartly = "https://plugin-code.salesmartly.com/js/project_685069_706560_1776407728.js";

const pageA: PageConfig = {
  enabled: true,
  label: "A",
  heroTag: { tj: "AZ TOJIKISTON", ru: "IZ TADZHIKISTANA" },
  heroTitle: { tj: "Imkoniyati kori onlayn", ru: "Vozmozhnost rabotat onlayn" },
  heroText: {
    tj: "Vaqti holi dored? Imkoniyati kori onlayn baroi shakhsoni ki mekhohand az khona bo telefon faoliyat kunand.",
    ru: "Est svobodnoe vremya? Uznayte bolshe o vozmozhnosti rabotat iz doma s pomoshchyu telefona i interneta."
  },
  heroButton: { tj: "Payom firisted", ru: "Otpravit soobshchenie" },
  heroImage: "/assets/hero-home.svg",
  storyTitle: { tj: "Kor az khona, bo ravandi sodda", ru: "Rabota iz doma, prostoy format" },
  storyText: {
    tj: "Mushovir shart, vaqt va qadamhoi ogozro dar chat mefahmonad. Hamai savolho dar hamin sahifa pursida meshavand.",
    ru: "Konsultant oby asnit usloviya, vremya i shagi starta v chate. Voprosy mozhno zadat pryamo na etoy stranitse."
  },
  benefits: [
    { icon: "globe", title: { tj: "100% onlayn", ru: "100% onlayn" }, body: { tj: "Az khona yo joi qulay", ru: "Iz doma ili udobnogo mesta" } },
    { icon: "phone", title: { tj: "Telefon va internet", ru: "Telefon i internet" }, body: { tj: "Baroi ogoz kifoya ast", ru: "Dostatochno dlya starta" } },
    { icon: "clock", title: { tj: "Vaqti chandir", ru: "Gibkoe vremya" }, body: { tj: "Vaqti qulayro intikhob kuned", ru: "Vybirayte udobnoe vremya" } },
    { icon: "school", title: { tj: "Omuzish hast", ru: "Est obuchenie" }, body: { tj: "Qadamho sharh doda meshavand", ru: "Shagi budut obyasneny" } }
  ],
  audience: [
    { tj: "Donishjuyon", ru: "Studentam" },
    { tj: "Khonashinho", ru: "Tem, kto doma" },
    { tj: "Kormandoni vaqti ozod doshta", ru: "Tem, u kogo est svobodnoe vremya" }
  ],
  requirements: [
    { tj: "18 sola va bolo", ru: "Ot 18 let" },
    { tj: "Telefon va internet", ru: "Telefon i internet" },
    { tj: "Masuliyat va omodagi ba omuzish", ru: "Otvetstvennost i gotovnost uchitsya" }
  ],
  consultTitle: { tj: "Malumoti purra dar payom", ru: "Podrobnosti v soobshcheniyakh" },
  consultText: { tj: "Tugmaro pakhsh kuned, chat dar hamin sahifa mekushoyad.", ru: "Nazhmite knopku, chat otkroetsya na etoy stranitse." },
  consultButton: { tj: "Ogozi suhbat", ru: "Nachat dialog" },
  quickQuestions: [
    { tj: "In chi guna faoliyat ast?", ru: "Chto eto za deyatelnost?" },
    { tj: "Chi guna ogoz kunam?", ru: "Kak nachat?" },
    { tj: "Tajriba lozim ast?", ru: "Nuzhen opyt?" }
  ],
  faq: [
    { question: { tj: "Oyo tajriba lozim?", ru: "Nuzhen opyt?" }, answer: { tj: "Qadamhoi asosi dar chat sharh doda meshavand.", ru: "Osnovnye shagi obyasnyayutsya v chate." } },
    { question: { tj: "Dar kujo savol diham?", ru: "Gde zadat vopros?" }, answer: { tj: "Dar hamin sahifa tugmai chatro pakhsh kuned.", ru: "Nazhmite knopku chata na etoy stranitse." } }
  ],
  footer: { tj: "Malumot khususiyati mashvarati dorad.", ru: "Informatsiya nosit konsultatsionnyy kharakter." }
};

const pageB: PageConfig = {
  ...pageA,
  label: "B",
  heroTag: { tj: "KOR AZ KHONA", ru: "RABOTA IZ DOMA" },
  heroTitle: { tj: "Bo telefon imkoniyati navro sanjed", ru: "Poprobuyte novuyu vozmozhnost s telefona" },
  heroText: {
    tj: "Agar vaqti kholi dored, mushovir ba shumo shakli kor, talabho va qadamhoi ogozro mefahmonad.",
    ru: "Esli est svobodnoe vremya, konsultant obyasnit format, trebovaniya i shagi starta."
  },
  heroButton: { tj: "Savol dodan", ru: "Zadat vopros" },
  heroImage: "/assets/hero-lifestyle.svg",
  consultButton: { tj: "Mashvarat giriftan", ru: "Poluchit konsultatsiyu" }
};

export const defaultConfig: SiteConfig = {
  siteName: "Tajik Online Work",
  brand: "Online Work TJ",
  defaultLocale: "tj",
  showLanguageSwitch: true,
  primaryColor: "#0b6e3a",
  accentColor: "#ffc73a",
  backgroundColor: "#f7f6ec",
  ab: { enabled: true, ratioA: 50, ratioB: 50, cookieDays: 14, defaultVariant: "a" },
  chat: {
    enabled: true,
    inviteDelaySeconds: 4,
    stickyChannel: true,
    channels: [{ id: "salesmartly", name: "SaleSmartly Main", type: "salesmartly", enabled: true, weight: 100, scriptUrl: salesmartly, targetUrl: "", buttonText: { tj: "Ogozi suhbat", ru: "Nachat dialog" } }]
  },
  pixel: { enabled: false, id: "", pageView: true, contact: true },
  safety: { enabled: true, allowedCountries: ["TJ"], nonTargetMode: "safe_home", dedupeSeconds: 30, ctaLimitPerMinute: 5 },
  pages: { a: pageA, b: pageB }
};

export const defaultStats: Stats = {
  aViews: 0,
  bViews: 0,
  aContacts: 0,
  bContacts: 0,
  duplicateEvents: 0,
  safeHomeViews: 0
};

export function cloneDefaultConfig(): SiteConfig {
  return JSON.parse(JSON.stringify(defaultConfig)) as SiteConfig;
}
